import { ApiError } from '@/api/envelope';

/** The server's own sentence for a refusal, or the fallback. */
export function serverSentence(error: unknown, fallback: string): string {
  return (error instanceof ApiError ? error.serverMessage : null) ?? fallback;
}
